"use client";

import { useEffect, useState } from "react";
import { getInsightsApi } from "../../utils/get-insights";

type CheckInConfirmedBookings = {
  percentage: number;
};

type UseCheckInConfirmedBookingsProps = {
  startDate: string;
  endDate: string;
  companyId: number;
};

export function useCheckInConfirmedBookings({
  startDate,
  endDate,
  companyId,
}: UseCheckInConfirmedBookingsProps) {
  const [data, setData] = useState<CheckInConfirmedBookings>();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!startDate || !endDate || !companyId) {
      return;
    }

    const fetchData = async () => {
      try {
        setIsLoading(true);

        const response = await getInsightsApi(
          "/checkin-percentage",
          startDate,
          endDate,
          12000,
          companyId.toString(),
        );

        setData(response);
      } catch (error) {
        console.error("Erro ao buscar dados de distribuição por dia:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate, companyId]);

  return { data, isLoading };
}
